import * as types from '../types'

/**
 * 特殊活动数据
 * id: 1 优惠推荐
 * id: 2 好物预售
 * @type {Object}
 */
const state = {
    info: [
        {
            id: 1,
            title: '优惠推荐',
            desc: '尊重自然的安全农业“看天吃饭”，来之不易！这个栏目除了释放折扣回馈您给予鼓励的同时，也希望您能在良心农遭遇台风、水涝、干旱等极端天气，食材的品相降低但不影响食用的情况下，对这些勤勤恳恳按照原味生活的标准去艰苦劳作的他们给予支持，等到了来年，良心农户也定会记得您的恩情，在此先谢谢了!',
            thumb: 'event1.jpg',
            goodsList: []
        },
        {
            id: 2,
            title: '好物预售',
            desc: '',
            thumb: 'event2.jpg',
            goodsList: []
        },
        {
            id: 3,
            title: '当季新品',
            desc: '',
            thumb: 'event3.jpg',
            goodsList: []
        }
    ]
}

const getters = {
}

const mutations = {
    [types.UPDATE_EVENTS_LIST] (state, params) {
        state.info.forEach((item) => {
            if (params.id == item.id) {
                item.goodsList = params.list
            }
        })
    }
}

const actions = {

}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/events.js